import Component from '@glimmer/component'
import lessonResourcesGreen from '@images/homeschool-ui-icons/lesson_resources_green.svg'
import lessonResourcesBlue from '@images/homeschool-ui-icons/lesson_resources_blue.svg'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import HomeschoolBaseTile from 'teacher-ui-client/components/home/tiles/homeschool/base-tile'
import { t } from 'ember-intl'
import { TileButton } from 'teacher-ui-client/components/home/tiles/homeschool/button'
import { hash } from '@ember/helper'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Args: {
    subscriptionType: SubscriptionType.Reading | SubscriptionType.Maths
  }
  Element: Element
}

export class LessonResourcesTile extends Component<Signature> {
  get isMathsSubscription() {
    return this.args.subscriptionType === SubscriptionType.Maths
  }

  get isReadingSubscription() {
    return this.args.subscriptionType === SubscriptionType.Reading
  }

  <template>
    {{#if this.isMathsSubscription}}
      <HomeschoolBaseTile
        @themeKey={{ThemeKeys.green}}
        @imgSrc={{lessonResourcesBlue}}
        @imgAlt={{t "pages.home.panels.homeschool.lessonResources.imageAlt"}}
        @title={{t "pages.home.panels.homeschool.lessonResources.title"}}
        @tileDescription={{t "pages.home.panels.homeschool.lessonResources.description"}}
      >
        <div class="flex flex-col items-center space-y-4 text-center">
          <TileButton
            @title={{t "pages.home.panels.homeschool.lessonResources.buttonText.ms"}}
            @themeKey={{ThemeKeys.blue}}
            @route="subscription-type.lessons.mathseeds.previews"
            @query={{hash precinct=Precinct.MS_LESSONS pageNumber=1}}
            data-test-homeschool-lesson-resources-button-ms
          />
        </div>
      </HomeschoolBaseTile>

    {{else if this.isReadingSubscription}}
      <HomeschoolBaseTile
        @themeKey={{ThemeKeys.blue}}
        @imgSrc={{lessonResourcesGreen}}
        @imgAlt={{t "pages.home.panels.homeschool.lessonResources.imageAlt"}}
        @title={{t "pages.home.panels.homeschool.lessonResources.title"}}
        @tileDescription={{t "pages.home.panels.homeschool.lessonResources.description"}}
      >
        <div class="flex flex-col items-center space-y-4 text-center">
          <TileButton
            @title={{t "pages.home.panels.homeschool.lessonResources.buttonText.re"}}
            @themeKey={{ThemeKeys.blue}}
            @route="subscription-type.lessons.reading-eggs.previews"
            @query={{hash precinct=Precinct.RE_READING pageNumber=1}}
            data-test-homeschool-lesson-resources-button-re
          />
          <TileButton
            @title={{t "pages.home.panels.homeschool.lessonResources.buttonText.rex"}}
            @themeKey={{ThemeKeys.purple}}
            @route="subscription-type.lessons.reading-eggspress.previews"
            @query={{hash precinct=Precinct.REX_READING pageNumber=1}}
            data-test-homeschool-lesson-resources-button-rex
          />
          <TileButton
            @title={{t "pages.home.panels.homeschool.lessonResources.buttonText.fp"}}
            @themeKey={{ThemeKeys.pink}}
            @route="subscription-type.lessons.fast-phonics.previews"
            @query={{hash precinct=Precinct.FP_PEAKS pageNumber=1}}
            data-test-homeschool-lesson-resources-button-fp
          />
        </div>
      </HomeschoolBaseTile>

    {{/if}}
  </template>
}

export default LessonResourcesTile
